import * as React from "react";
import { Link } from "react-router-dom";
import { WrappedComponentProps, injectIntl } from "react-intl";
// helpers
import { logException } from "@vingle/wtf-sdk/helpers/errorLogger";
// interfaces
import { summarize } from "@vingle/wtf-sdk/models/post";
// components
import ContentPlaceholder from "..";
import RoundImage from "common/components/roundImage";
import ShavedText from "common/components/shavedText";
// constants
import { GREY500 } from "@vingle/wtf-sdk/constants/palette";
import { MAX_SHARED_CARD_CONTENT_WIDTH } from "../helper/constants";
// styles

import { VingleURL } from "@vingle/wtf-sdk/url";
const styles = require("./originCard.scss");

interface IProps extends WrappedComponentProps {
  originCard: Vingle.Post.IPost;
  paperStyle?: React.CSSProperties;
  wrapperClassName?: string;
  userInfoWrapperClassName?: string;
  titleClassName?: string;
  summaryClassName?: string;
  mediaClassName?: string;
  contentPlaceholderWidth?: number;
  contentPlaceholderHeight?: number;
  titleLineHeight?: number;
}

const BASIC_PAPER_STYLE = {
  padding: "20px",
  borderRadius: "6px",
  border: `solid 1px ${GREY500}`,
};

const DEFAULT_TITLE_LINE_HEIGHT = 26;
const SUMMARY_LINE_HEIGHT = 24;

class OriginCard extends React.PureComponent<IProps> {
  public componentDidCatch(error: Error, context: any) {
    logException({ error, context });
  }

  public render() {
    const {
      originCard,
      paperStyle,
      wrapperClassName,
      userInfoWrapperClassName,
      summaryClassName,
      mediaClassName,
      contentPlaceholderWidth,
      contentPlaceholderHeight,
    } = this.props;

    const contentWidth = contentPlaceholderWidth
      ? contentPlaceholderWidth
      : MAX_SHARED_CARD_CONTENT_WIDTH;
    const contentHeight = contentPlaceholderHeight
      ? contentPlaceholderHeight
      : MAX_SHARED_CARD_CONTENT_WIDTH;

    let mediaThumbnail: React.ReactNode | null = null;
    const selfSummary = summarize(originCard.content);
    if (selfSummary.media && selfSummary.media.length > 0) {
      mediaThumbnail = (
        <ContentPlaceholder
          width={contentWidth}
          height={contentHeight}
          data={selfSummary.media}
          targetUrl={new VingleURL.PostShow({
            cardId: originCard.id,
          }).toLocation({
            modal: true,
            withBrowserSearch: true,
          })}
        />
      );
    } else {
      mediaThumbnail = null;
    }

    const postShowLocation = new VingleURL.PostShow({
      cardId: originCard.id,
    }).toLocation({
      withBrowserSearch: true,
    });

    const combinedPaperStyle = { ...BASIC_PAPER_STYLE, ...paperStyle };

    return (
      <div
        className={`${styles.originPaper} ${wrapperClassName}`}
        style={combinedPaperStyle}
      >
        <div className={`${styles.userInfo} ${userInfoWrapperClassName}`}>
          <RoundImage
            imageSrc={originCard.author.profile_image_urls}
            width={36}
            height={36}
          />
          <Link
            className={styles.username}
            to={new VingleURL.UserShow({
              username: originCard.author.username,
            }).toString()}
          >
            {originCard.author.username}
          </Link>
        </div>
        {this.renderTitle()}
        <div className={`${styles.summary} ${summaryClassName}`}>
          <Link to={postShowLocation}>
            <ShavedText
              value={selfSummary.text}
              shaveHeight={SUMMARY_LINE_HEIGHT * 3}
              ellipsisText={this.props.intl.formatMessage({
                id: "summary_readmore",
              })}
            />
          </Link>
        </div>

        <div className={`${styles.media} ${mediaClassName}`}>
          {mediaThumbnail}
        </div>
      </div>
    );
  }

  private readonly renderTitle = () => {
    const { originCard, titleClassName, titleLineHeight } = this.props;
    const postShowLocation = new VingleURL.PostShow({
      cardId: originCard.id,
    }).toLocation({
      withBrowserSearch: true,
    });
    const shaveTitleLineHeight = titleLineHeight
      ? titleLineHeight
      : DEFAULT_TITLE_LINE_HEIGHT;
    return (
      originCard.title && (
        <Link
          to={postShowLocation}
          className={`${styles.title} ${titleClassName}`}
        >
          <ShavedText
            value={originCard.title}
            shaveHeight={shaveTitleLineHeight}
          />
        </Link>
      )
    );
  };
}

export default injectIntl(OriginCard);
